var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.176483 2.82357C0.176483 1.36164 1.36161 0.176514 2.82354 0.176514H21.1765C22.6384 0.176514 23.8235 1.36164 23.8235 2.82357V21.1765C23.8235 22.6384 22.6384 23.8236 21.1765 23.8236H2.82354C1.36161 23.8236 0.176483 22.6384 0.176483 21.1765V2.82357ZM2.82354 1.23534C1.94638 1.23534 1.23531 1.94641 1.23531 2.82357V21.1765C1.23531 22.0537 1.94638 22.7647 2.82354 22.7647H21.1765C22.0536 22.7647 22.7647 22.0537 22.7647 21.1765V2.82357C22.7647 1.94641 22.0536 1.23534 21.1765 1.23534H2.82354Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.64706 5.64709C8.64706 5.3547 8.88409 5.11768 9.17648 5.11768H19.7647C20.0571 5.11768 20.2941 5.3547 20.2941 5.64709C20.2941 5.93947 20.0571 6.1765 19.7647 6.1765H9.17648C8.88409 6.1765 8.64706 5.93947 8.64706 5.64709Z",
    fill: "inherit"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.64706 12C8.64706 11.7076 8.88409 11.4706 9.17648 11.4706H19.7647C20.0571 11.4706 20.2941 11.7076 20.2941 12C20.2941 12.2924 20.0571 12.5294 19.7647 12.5294H9.17648C8.88409 12.5294 8.64706 12.2924 8.64706 12Z",
    fill: "inherit"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.64706 18.3529C8.64706 18.0605 8.88409 17.8235 9.17648 17.8235H19.7647C20.0571 17.8235 20.2941 18.0605 20.2941 18.3529C20.2941 18.6453 20.0571 18.8823 19.7647 18.8823H9.17648C8.88409 18.8823 8.64706 18.6453 8.64706 18.3529Z",
    fill: "inherit"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.94118 4.76476C4.45387 4.76476 4.05882 5.1598 4.05882 5.64711C4.05882 6.13442 4.45387 6.52946 4.94118 6.52946C5.42849 6.52946 5.82353 6.13442 5.82353 5.64711C5.82353 5.1598 5.42849 4.76476 4.94118 4.76476ZM3 5.64711C3 4.57503 3.86909 3.70593 4.94118 3.70593C6.01326 3.70593 6.88235 4.57503 6.88235 5.64711C6.88235 6.71919 6.01326 7.58829 4.94118 7.58829C3.86909 7.58829 3 6.71919 3 5.64711Z",
    fill: "inherit"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.94118 11.1177C4.45387 11.1177 4.05882 11.5127 4.05882 12C4.05882 12.4873 4.45387 12.8824 4.94118 12.8824C5.42849 12.8824 5.82353 12.4873 5.82353 12C5.82353 11.5127 5.42849 11.1177 4.94118 11.1177ZM3 12C3 10.9279 3.86909 10.0588 4.94118 10.0588C6.01326 10.0588 6.88235 10.9279 6.88235 12C6.88235 13.0721 6.01326 13.9412 4.94118 13.9412C3.86909 13.9412 3 13.0721 3 12Z",
    fill: "inherit"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.94118 17.4706C4.45387 17.4706 4.05882 17.8656 4.05882 18.3529C4.05882 18.8402 4.45387 19.2353 4.94118 19.2353C5.42849 19.2353 5.82353 18.8402 5.82353 18.3529C5.82353 17.8656 5.42849 17.4706 4.94118 17.4706ZM3 18.3529C3 17.2808 3.86909 16.4117 4.94118 16.4117C6.01326 16.4117 6.88235 17.2808 6.88235 18.3529C6.88235 19.425 6.01326 20.2941 4.94118 20.2941C3.86909 20.2941 3 19.425 3 18.3529Z",
    fill: "inherit"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/Category.137c20a30154b87d564655b81583c8fe.svg";
export { ForwardRef as ReactComponent };